import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.string.replace-all.js";
const nodeUrl = require('url');
export default {
  data() {
    return {
      sessionId: '',
      summaryTime: '',
      summaryDate: []
    };
  },
  created() {
    const URL = nodeUrl.parse(location.href, true);
    this.sessionId = URL.query.sessionId;
    // this.getSession()
    this.getHistory();
  },
  methods: {
    getSession() {
      this.axios.get('/partyline-backend/stt/transcript/lastSession/604558761892').then(res => {
        if (res.data.errorCode == '0x0') {
          this.sessionId = res.data.result;
          this.getHistory();
        }
      });
    },
    getHistory() {
      this.summaryDate = [];
      this.axios.get(`/partyline-backend/stt/transcript/q2?session=${this.sessionId}`).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          if (result) {
            result.records.forEach(item => {
              const decodedBytes = atob(item.text);
              const utf8Decoder = new TextDecoder();
              const originalContent = utf8Decoder.decode(new Uint8Array(decodedBytes.split('').map(char => char.charCodeAt(0))));
              item.text = originalContent;
            });
            this.summaryDate = result.records;
            if (result.startTime && result.endTime) {
              const year = new Date(result.startTime).toLocaleDateString().replaceAll('/', '-');
              const startTime = this.formatTime(result.startTime);
              const endTime = this.formatTime(result.endTime);
              this.summaryTime = `${year} ${startTime} ~ ${endTime}`;
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
        }
      });
    },
    formatTime(date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      return hours + ':' + minutes;
    },
    retrunTime(item) {
      return this.formatTime(item.endTime) + ' ' + (new Date(item.endTime).getHours() > 12 ? 'PM' : 'AM');
    }
  }
};